import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { embedDashboard } from "amazon-quicksight-embedding-sdk";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import ReportService from "@services/Report";
import settings from "@settings/index";

const useStyles = makeStyles({
  container: {
    paddingTop: "15px",
  },
  iframe: {},
  failed: {
    display: "block",
    marginBottom: "15px",
    textAlign: "center",
  },
});

function Report(props) {
  const classes = useStyles();
  const username = useSelector((state) => state.auth.username);

  const [failed, setFailed] = useState(false);
  const [size, setSize] = useState(null);
  const [embeddedUrl, setEmbeddedUrl] = useState("");

  function processSize() {
    let size = null;

    if (window.innerWidth < 1400) {
      size = {
        width: "100%",
        height: "580px",
      };
    } else if (window.innerWidth < 1700) {
      size = {
        width: "100%",
        height: "700px",
      };
    } else {
      size = {
        width: "100%",
        height: "780px",
      };
    }

    setSize(size);
  }

  function renderReport() {
    const { width, height } = size;
    const options = {
      width,
      height,
      url: embeddedUrl,
      container: "#iframe-container",
      scrolling: "yes",
      locale: "pt-BR",
      footerPaddingEnabled: true,
      parameters: {
        user: username,
      },
    };
    embedDashboard(options);
  }

  useEffect(() => {
    ReportService.generateEmbeddedUrl(props.quickSightID)
      .then((response) => {
        let url = response.embeddedUrl;
        if (settings.reports.URL) {
          url = url.replace(
            /http[s]?[:]\/\/[a-zA-Z0-9_.-]*\//,
            settings.reports.URL
          );
        }
        setEmbeddedUrl(url);
      })
      .catch(() => {
        setFailed(true);
      });
  }, []);

  useEffect(() => {
    processSize();
  }, []);

  useEffect(() => {
    if (embeddedUrl && size) {
      renderReport();
    }
  }, [embeddedUrl, size]);

  return (
    <div className={classes.container}>
      <div id="iframe-container" className={classes.iframe}>
        {failed && (
          <Typography variant="body1" className={classes.failed}>
            Erro ao carregar Quicksight!
          </Typography>
        )}
      </div>
    </div>
  );
}

Report.propTypes = {
  quickSightID: PropTypes.string.isRequired,
};

Report.defaultProps = {
  quickSightID: "",
};

export default Report;
